import { render, staticRenderFns } from "./productcenterjgyj.vue?vue&type=template&id=42f1dc8d&scoped=true&"
import script from "./productcenterjgyj.vue?vue&type=script&lang=js&"
export * from "./productcenterjgyj.vue?vue&type=script&lang=js&"
import style0 from "./productcenterjgyj.vue?vue&type=style&index=0&id=42f1dc8d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f1dc8d",
  null
  
)

export default component.exports